var React = require('react');

function GhostCliLogo (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"strokeOpacity":".012","stroke":"#000","strokeWidth":"0","d":"M2 2h38v38H2z","key":0}),React.createElement("g",{"stroke":"#343F44","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M13.875 14.667l3.958 3.958-3.958 3.958M22.583 19.417h6.334","key":0}),React.createElement("path",{"d":"M4.375 5.167h33.25c1.056 0 1.583.527 1.583 1.583v28.5c0 1.056-.527 1.583-1.583 1.583H4.375c-1.056 0-1.583-.527-1.583-1.583V6.75c0-1.056.527-1.583 1.583-1.583z","key":1}),React.createElement("path",{"d":"M6.75 8.333h28.5c.528 0 .792.264.792.792v23.75c0 .528-.264.792-.792.792H6.75c-.528 0-.792-.264-.792-.792V9.125c0-.528.264-.792.792-.792z","key":2})])]));
}

GhostCliLogo.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42"};

module.exports = GhostCliLogo;

GhostCliLogo.default = GhostCliLogo;
